import { render } from "./ForecastDetails.vue?vue&type=template&id=bef407e4"
import script from "./ForecastDetails.vue?vue&type=script&lang=js"
export * from "./ForecastDetails.vue?vue&type=script&lang=js"

import "./ForecastDetails.vue?vue&type=style&index=0&id=bef407e4&lang=css"

import exportComponent from "/root/dirif/prod/dirif-fo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__